module.exports = __webpack_public_path__ + "img/HappyPhoto8.c9f559c2.jpeg";